<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="user.FirstName + ', API User :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light" v-if="this.$root.hasPermission('settings.manage.users')">
                        <router-link :to="`/admin/api-users`">
                            <i class="fa fa-sitemap"></i> API Users
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        {{ user.FirstName }}
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-lg-8 col-md-12">
                    <div class="card mb-3">
                        <div class="card-header">
                            <strong>
                                API User Details
                            </strong>

                            <router-link :to="`/admin/api-users/edit/${user.UserId}`" class="btn btn-sm btn-light">
                                <i class="fa fa-edit"></i> Edit
                            </router-link>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="row mb-2">
                                        <div class="col text-muted">Status</div>
                                        <div class="col-md-8">
                                            <span class="badge badge-success" v-if="user.IsActive == 1">Active</span>
                                            <span class="badge badge-warning" v-else>Inactive</span>
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col text-muted">Name:</div>
                                        <div class="col-md-8">{{ user.FirstName }}</div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col text-muted">Last Login:</div>
                                        <div class="col-md-8"><span v-if="user.LastLoginDate">{{ user.LastLoginDate | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm A") }}</span></div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col text-muted">Token Expires:</div>
                                        <div class="col-md-8">{{ user.expires_at | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm A") }}</div>
                                    </div>
                                </div>
                            </div>
                            <hr/>

                            <div class="card bg-light">
                                <div class="card-header">
                                    Access Token:
                                </div>
                                <div class="card-body">
                                    {{ user.api_access_token }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-12">
                    <div class="card mb-3">
                        <div class="card-header"><strong><i class="fa fa-lock"></i> Permissions</strong></div>
                        <div class="card-body">
                            <div class="align-items-center" v-for="perm in user.permissions">
                                <div class="badge badge-secondary mt-1 mr-1">{{ perm.name }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                userTimezone: this.$store.state.user.timezone,
                UserId: this.$route.params.id,
                user: {},
            }
        },

        methods: {

            getUser: function() {
                //Get the data
                this.$http
                    .get('admin/api-users/view/' + this.UserId)
                    .then(response => {
                        //Set all the data
                        this.user = response.data.user;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

        },
        mounted() {
            //Get the users
            this.getUser();
        }
    }
</script>
